module.exports = __webpack_public_path__ + "img/guide_11.28dfe2df.png";